import React from "react";
import { render } from "react-dom";
import translations from 'shared/lib/translations';

import App from "fantastic/components/App";

const renderPack = () => {
  const container = document.getElementById("fantastic-app");
  const locales = document.getElementById('fantastic-app-locales');
  translations(JSON.parse(locales.innerHTML));
  render(<App {...container.dataset} />, container);
};
document.addEventListener("DOMContentLoaded", renderPack);
